import React, { useId, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import FactorChoice from "./FactorChoice";
import "./nudge.css";

const TodayCopy = ({ titleId }) => (
  <>
    <h2 id={titleId}>Protect your account with an authenticator app</h2>
    <p>
      Each time you sign in, you&apos;ll enter a 6-digit code from an app on your phone (Google Authenticator,
      Microsoft Authenticator or similar) instead of waiting for an email. It takes about 2 minutes.
    </p>
  </>
);

// Direction A (Amar, 2026-10-22): a centred modal on desktop, a bottom sheet below 576px (nudge.css).
// Presentational only; the rules for when it shows are in useMfaNudge. Esc, outside click and skip are one thing.
// offerSms (docs/specs/sms-factor.md §1, A2 decided A): the title asks for "a second step" and FactorChoice picks
// the factor, authenticator pre-selected; "Continue" hands the pick to onSetUp. Without it: today's nudge.
const MfaNudgeModal = ({ open, offerSms = false, onSetUp, onSkip }) => {
  const titleId = useId();
  const [factor, setFactor] = useState("totp");
  return (
    <Modal show={open} animation={false} onHide={onSkip} aria-labelledby={titleId} className="mfa-nudge">
      <Modal.Body>
        <span className="mfa-nudge-icon" aria-hidden="true">
          <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#ef8860" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z" />
            <path d="M9 12l2 2 4-4" />
          </svg>
        </span>
        {offerSms ? (
          <>
            <h2 id={titleId}>Add a second step to sign-in</h2>
            <FactorChoice value={factor} onChange={setFactor} />
          </>
        ) : (
          <TodayCopy titleId={titleId} />
        )}
        <div className="mfa-nudge-actions">
          <Button variant="outline-secondary" className="mfa-btn-quiet" type="button" onClick={onSkip}>Skip for now</Button>
          <Button type="button" className="text-white fw-bold" onClick={() => onSetUp(factor)}>
            {offerSms ? "Continue" : "Set up now"}
          </Button>
        </div>
        <small>You can also set it up any time in My Profile → Security. We&apos;ll ask again in 7 days.</small>
      </Modal.Body>
    </Modal>
  );
};

export default MfaNudgeModal;
